import React from 'react';
// import '../style/Modal.css'; // Reuse your existing modal styles or create new ones

const SessionExpiredModal = ({ isOpen, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '400px', textAlign: 'center' }}>
        <h2 style={{ color: '#d9534f' }}>Session Expired</h2>
        <p style={{ margin: '20px 0' }}>
          Your session has been revoked or has expired. <br/>
          Please login again to continue.
        </p>
        <p style={{ fontSize: '0.9em', color: '#666' }}>
          If you have any questions, please contact the Admin.
        </p>
        <button 
          className="modal-btn primary" 
          onClick={onConfirm}
          style={{ width: '100%', marginTop: '15px' }}
        >
          Return to Login
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
